import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserLicence, UserLicenceAdd } from 'app/shared/models/Users/user';
import { UserService } from 'app/shared/services/user/user.service';

export interface DialogData {
  userFfv: UserLicence
}


@Component({
  selector: 'app-opendialog-create-user-ffv-licence',
  templateUrl: './opendialog-create-user-ffv-licence.component.html',
  styleUrls: ['./opendialog-create-user-ffv-licence.component.scss']
})
export class OpendialogCreateUserFfvLicenceComponent implements OnInit {

  userSendByFfv: UserLicenceAdd = {
    firstName: null,
    lastName: null,
    email: null,
    licence: null,
  };

  constructor(
    public dialogRef: MatDialogRef<OpendialogCreateUserFfvLicenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    this.getUserByNLicence(this.data.userFfv);
  }

  private getUserByNLicence(user: UserLicence): void {
    this.userService.getUserLicenceFFV(user).subscribe(res => {
      this.userSendByFfv.email = res.email;
      this.userSendByFfv.firstName = res.prenom;
      this.userSendByFfv.lastName = res.nom;
      this.userSendByFfv.licence = res.nO_LICENCE;
      this.cdr.detectChanges();
    });
  }

}
